import { createSlice } from '@reduxjs/toolkit'

export const notesSlice = createSlice({
  name: 'notes',
  initialState: {
    value: [],
  },
  reducers: {
    storeNotes: (state, action) => {
      state.value = action.payload
    },
    cleanNotes: (state) => {
        state.value = [];
    },
    addNoteToNotes: (state, action) => {
        // @ts-ignore
        state.value = state.value.push(action.payload);
    }
  },
})
export const { storeNotes, cleanNotes, addNoteToNotes } = notesSlice.actions

export default notesSlice.reducer